export interface IEquipment {
  class: Classes;
  subClass: string;
  name: string;
  imageUrl: string;
}

export enum Classes {
  CALIBRATION, CALIFICATION, TEST
}

export enum CalibrationClasses {
  TEMPERATURE = 'temperatura',
  PRESION = 'presión',
  MASS = 'masa',
  HUMIDITY = 'humedad',
  DIMENSION = 'dimensional',
  VOLUME = 'volumen',
  OPTICS = 'óptica',
  DENSITY = 'densidad'
}

export enum CalificationClasses {
  EQUIPMENT = 'Calificación de Equipos',
  EIMAS = 'Calificación de EIMA\'s',
}

export enum TestClasses {
  MECHANICS = 'Metal Mecánica (Prueba de válvulas)'
}
